<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6">
        <v-card-title class="mt-4">
          <v-btn class="mr-2" fab x-small color="#6c5dd4" @click="$router.back()">
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn>Add a Value
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="12">
              <v-col sm="6">
                <v-text-field @input="form.name = form.name ? form.name.toUpperCase() : ''" v-model="form.name" outlined label="Name"
                  prepend-inner-icon="mdi-card-text-outline"></v-text-field>
              </v-col>
            </v-col>
            <v-col>
              <v-btn class="float-end" :loading="isLoading" color="#6c5dd4" dark @click="save"> Save Value </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "ValueCreatePage",
  data() {
    return {
      form: {
        name: "",
      },
      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/values", this.form);
        this.isLoading = false;
        this.$router.push("/values");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
